<template>
  <div>
    <p class="mb-2 mt-4">Search with:</p>
    <div>
      <gl-form-radio
        @change="setSearchParameter"
        v-model="searchTypeSelected"
        value="companyName"
        >Company name
      </gl-form-radio>
      <gl-form-radio
        @change="setSearchParameter"
        v-model="searchTypeSelected"
        value="vendorId"
        >Vendor ID
      </gl-form-radio>
    </div>
    <gl-form-group
      id="business-name-group"
      :label="searchParameter.label"
      label-for="business-name"
      class="mb-4 mt-3"
    >
      <gl-form-combobox
        :token-list="formattedCompaniesList"
        label-text=""
        v-model="companyNameOrVendorId"
        :placeholder="searchParameter.placeholder"
        @value-selected="selectedCompany"
      />
    </gl-form-group>

    <gl-form-group
      v-if="selectedCompanyWallets.length > 1"
      id="wallet-currency-group"
      label="Select wallet currency"
      label-for="wallet-currency"
      class="mt-3"
    >
      <gl-form-select
        id="wallet-currency"
        v-model="selectedWalletId"
        :options="walletOptions"
        @change="onWalletSelected"
      />
    </gl-form-group>
  </div>
</template>

<script>
import { GlFormGroup, GlFormRadio, GlFormCombobox, GlFormSelect } from '@gitlab/ui';

export default {
  name: 'GetWalletId',
  /**
   * The purpose of this component is to handle the
   *  search for companies by vendorId or company name
   * Since it's to be used across three places, it just
   * made sense to make it a component
   * */
  components: {
    GlFormGroup,
    GlFormRadio,
    GlFormCombobox,
    GlFormSelect,
  },
  data: () => ({
    companyNameOrVendorId: '',
    searchTypeSelected: 'companyName',
    searchParameter: {
      label: 'Company name',
      placeholder: 'Enter company name',
    },
    fullCompaniesList: [],
    formattedCompaniesList: [],
    selectedCompanyWallets: [],
    selectedWalletId: null,
  }),
  computed: {
    walletOptions() {
      return [
        { value: null, text: 'Select a currency' },
        ...this.selectedCompanyWallets.map((wallet) => ({
          value: wallet.id,
          text: wallet.currency,
        })),
      ];
    },
  },
  methods: {
    toggleLoading(isLoading) {
      this.$store.dispatch('loading/toggleLoading', isLoading);
    },
    setSearchParameter(value) {
      if (value === 'vendorId') {
        this.searchParameter.label = 'Vendor ID';
        this.searchParameter.placeholder = 'Enter vendor ID';
      } else {
        this.searchParameter.label = 'Company name';
        this.searchParameter.placeholder = 'Enter company name';
      }
    },
    async getAllCompanies() {
      this.toggleLoading(true);
      const response = await this.$store.dispatch('companies/getCompaniesLite');
      this.processCompaniesList(response);
      this.toggleLoading(false);
    },

    processCompaniesList(companies) {
      if (companies && companies.length > 0) {
        this.fullCompaniesList = companies;
        this.formattedCompaniesList = companies
          .map((company) => `${company.id}-${company.name}`)
          .filter(Boolean);
      }
    },

    selectedCompany(value) {
      const selectedBusinessId = value.split('-')[0];
      const company = this.fullCompaniesList.find(
        (company) => company.id === +selectedBusinessId
      );

      // Reset wallet state on each selection
      this.selectedCompanyWallets = [];
      this.selectedWalletId = null;
      this.$emit('wallet-id', null);

      if (!company) return;

      const wallets = company.wallets || [];

      if (wallets.length === 0) {
        this.$store.dispatch('notifications/displayNotification', {
          message: "This business doesn't have a wallet set up yet.",
          type: 'warning',
        });
        return;
      }

      if (wallets.length === 1) {
        this.$emit('wallet-id', wallets[0].id);
        return;
      }

      // Multiple wallets — let the user pick a currency
      this.selectedCompanyWallets = wallets;
    },

    onWalletSelected(walletId) {
      if (walletId) {
        this.$emit('wallet-id', walletId);
      }
    },
  },
  beforeMount() {
    this.getAllCompanies();
  },
};
</script>

<style></style>
